import { useFormStore } from "@/store/form";
import { ShortFlowPersonalData } from "../short-flow-personal-data/ShortFlowPersonalData";
import FormPersonalData from "./FormPersonalData";
import Cookies from "js-cookie";
import PersonalDataWithOfferCookie from "./PersonalDataWithOfferCookie";
import { useConfigStore } from "@/store/config";

export function PersonalDataPage({ ignoreCookie }: { ignoreCookie?: boolean }) {
  const offerCookie = Cookies.get("offer");

  if (!offerCookie || ignoreCookie) {
    return <PersonalDataWithoutOfferCookie />;
  }

  return <PersonalDataWithOfferCookie offer={JSON.parse(offerCookie)} />;
}

export default PersonalDataPage;

function PersonalDataWithoutOfferCookie() {
  const form = useFormStore((store) => store.value);
  const shortFlowOn = useConfigStore((store) => store.shortFlowOn);
  const variantSpeedFlow = useConfigStore((store) => store.variantSpeedFlow);

  if (
    form.tipo === "MIGRACAO" &&
    shortFlowOn &&
    variantSpeedFlow.includes(form.utm_medium)
  ) {
    return <ShortFlowPersonalData />;
  }

  return <FormPersonalData />;
}
